import { MAX_PREVIEW_LENGTH } from './constants.js';

/**
 * Fill an alert template for the EDITOR preview (redesign Phase D).
 *
 * ==================== WHY THIS IS NOT THE REAL RENDERER ====================
 * `renderTemplate` lives in `@connaro/alerts` and is what actually runs when an
 * event fires. `apps/web` has no `@connaro/*` dependency — the Console is an
 * HTTP client and the API is the authority — so this is a second
 * implementation, and that is a real cost rather than a convenience.
 *
 * It is accepted for one reason: the alternative is an operator typing
 * `{displayName} just followed!` into a bare input and discovering what it
 * produces when it appears on their broadcast. A preview that is occasionally a
 * token behind is enormously better than no preview, and the drift is bounded —
 * `alerts-preview-tokens.integration.test.ts` holds this list against
 * `ALERT_TOKENS` from the package itself.
 *
 * It fills SYNTHETIC values, never a real event, and reaches nothing: this
 * module imports no client and names no route.
 * ==========================================================================
 */

/** Must match `ALERT_TOKENS`. Held there by a test that can see both. */
export const PREVIEW_VALUES: Readonly<Record<string, string>> = {
  username: 'kestrel_tv',
  displayName: 'Kestrel',
  platform: 'twitch',
  amount: '12.50',
  /*
   * A real message rather than a placeholder. `{text}` carries chat content,
   * which is the token most likely to be long — and an operator should meet
   * that in the preview rather than on air.
   */
  text: 'good luck tonight, been waiting all week for this one',
};

export function fillPreview(template: string): string {
  const filled = template.replace(/\{([a-zA-Z]+)\}/gu, (whole, name: string) => {
    const value = PREVIEW_VALUES[name];
    /*
     * An UNKNOWN token is left exactly as typed, matching `renderTemplate`,
     * which substitutes only the allowlist. Showing `{typo}` is how an operator
     * discovers they wrote one; blanking it would hide the mistake until it
     * reached a broadcast.
     */
    return value ?? whole;
  });

  return filled.length > MAX_PREVIEW_LENGTH ? `${filled.slice(0, MAX_PREVIEW_LENGTH)}…` : filled;
}
